import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import { Badge, Card, Dropdown, ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { useMenuBadge } from 'providers/MenuBadgeProvider';

// Колокольчик уведомлений. Содержит ТОЛЬКО реальные счётчики из платформы
// (AML, в будущем — chat unread в отдельной nav-кнопке). Falcon-template
// моки (rawNewNotifications / rawEarlierNotifications с John Doe «liked your
// photo» и т.п.) удалены — оператор путал их с реальными уведомлениями
// чата (cycle v65, 2026-05-28).

const renderTooltip = props => (
  <Tooltip style={{ position: 'fixed' }} id="button-tooltip" {...props}>
    Уведомления
  </Tooltip>
);

const NotificationDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  // amlCount читается из общего MenuBadgeProvider — тот же источник, что у
  // sidebar-badge. Раньше был отдельный amlNotificationStore (vanilla
  // pub/sub) → два независимых счётчика одной сущности рассинхронизировались
  // (см. ARCH-review #7 от 2026-05-18).
  const { counters } = useMenuBadge();
  const amlCount = counters.aml;
  const navigate = useNavigate();

  const handleToggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    const onScroll = () => {
      if (window.innerWidth < 1200) setIsOpen(false);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const totalCount = amlCount;

  return (
    <OverlayTrigger placement="bottom" overlay={renderTooltip}>
      <Dropdown navbar={true} as="li" show={isOpen} onToggle={handleToggle}>
        <Dropdown.Toggle
          bsPrefix="toggle"
          as={Link}
          to="#!"
          className={classNames('px-0 nav-link position-relative', {
            'notification-indicator notification-indicator-primary': totalCount === 0
          })}
        >
          <FontAwesomeIcon icon="bell" transform="shrink-6" className="fs-5" />
          {totalCount > 0 && (
            <Badge
              bg="danger"
              pill
              style={{
                position: 'absolute',
                top: 0,
                right: -2,
                fontSize: '0.6rem',
                minWidth: 16,
                padding: '2px 4px'
              }}
            >
              {totalCount}
            </Badge>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu-card dropdown-menu-end dropdown-caret dropdown-caret-bg">
          <Card
            className="dropdown-menu-notification dropdown-menu-end shadow-none"
            style={{ maxWidth: '20rem' }}
          >
            <FalconCardHeader
              className="card-header"
              title="Уведомления"
              titleTag="h6"
              light={false}
            />
            <ListGroup
              variant="flush"
              className="fw-normal fs-10 scrollbar"
              style={{ maxHeight: '19rem' }}
            >
              {amlCount > 0 ? (
                <ListGroup.Item
                  action
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleToggle();
                    navigate('/finmonitoring');
                  }}
                >
                  <div className="d-flex align-items-center gap-2 py-1">
                    <Badge bg="danger" style={{ fontSize: '0.7rem' }}>{amlCount}</Badge>
                    <div>
                      <div className="fw-semibold" style={{ fontSize: '0.8rem' }}>
                        Операции для разбора
                      </div>
                      <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                        Перейти на вкладку AML →
                      </div>
                    </div>
                  </div>
                </ListGroup.Item>
              ) : (
                <ListGroup.Item className="text-center text-muted py-3" style={{ fontSize: '0.8rem' }}>
                  Нет новых уведомлений
                </ListGroup.Item>
              )}
            </ListGroup>
          </Card>
        </Dropdown.Menu>
      </Dropdown>
    </OverlayTrigger>
  );
};

export default NotificationDropdown;
